import { useRef, useEffect } from "react";

export default function GoogleMapCard({ googleMapLink }) {
  const container = useRef(null);
  const card = useRef(null);
  const item = useRef(null);

  useEffect(() => {
    const cont = container.current;
    const c = card.current;
    const i = item.current;

    if (!cont) return;

    const onMove = (e) => {
      const rect = cont.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;

      const rotateY = x / 25;
      const rotateX = -y / 25;

      requestAnimationFrame(() => {
        c.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg)`;
        i.style.transform = `translateZ(50px) rotateY(${-rotateY}deg) rotateX(${-rotateX}deg)`;
      });
    };

    const reset = () => {
      requestAnimationFrame(() => {
        c.style.transform = "rotateY(0deg) rotateX(0deg)";
        i.style.transform = "translateZ(0px) rotateY(0deg) rotateX(0deg)";
      });
    };

    cont.addEventListener("mousemove", onMove);
    cont.addEventListener("mouseleave", reset);

    return () => {
      cont.removeEventListener("mousemove", onMove);
      cont.removeEventListener("mouseleave", reset);
    };
  }, []);

  return (
    <div className="div-in-section-bas">
      <div className="div-in-section-bas2">
        <div className="card3d-container" ref={container}>
          <div className="card3d" ref={card}>
            <iframe className="plugin-Google-Map" src={googleMapLink} loading="lazy" />
            <div className="card3d-content">
              <div className="card3d-item" ref={item}>Google Map</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
